import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, withDefaults } from 'vue'

type PropsType = {
  type?: string
  color?: string
  size?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    type: { default: 'mood_bad' },
    color: { default: 'color-dark1' },
    size: { default: '24' }
  },
  setup(__props: any) {

const props = __props as { type: string, color: string, size: string };



const style = computed<{ fontSize: string }>(() => {
  return { fontSize: props.size + 'px' }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(["material-icons", __props.color]),
    style: _normalizeStyle(_unref(style))
  }, _toDisplayString(__props.type), 7))
}
}

})